export default {
  meta: {
    title: '网规区域管理',
  },
};
